import { RenderingStatus, toRenderingStatus } from "Enumerations";

import { UseQueryResult } from "@tanstack/react-query";

// https://github.com/TanStack/query/issues/3975
export const getQueryRenderingStatus = <T>(response: UseQueryResult<T>): RenderingStatus =>
    response.status === "pending" ? (response.isFetching ? RenderingStatus.Waiting : RenderingStatus.Ready) : toRenderingStatus[response.status];
